export default {
  title: 'Umsatzsteuer nach Unternehmen / Praxis',
  defaultVat: 'Standard-Umsatzsteuer',
  explanation: 'Die Standard-Umsatzsteuer gilt, sofern für ein Unternehmen keine eigene Einstellung festgelegt ist. '
    + 'Unternehmensspezifische Steuersätze werden als Prozentsatz des Leistungspreises berechnet.',
  inherit: 'Standard-Umsatzsteuer verwenden',
  disabled: 'Umsatzsteuer deaktiviert',
  enabled: 'Unternehmensspezifischen Steuersatz verwenden',
  rate: 'Umsatzsteuersatz (%)',
  rateError: 'Geben Sie einen Steuersatz zwischen 0 und 100 ein.',
  loadError: 'Die Umsatzsteuereinstellungen konnten nicht geladen werden. '
    + 'Öffnen Sie das Formular erneut, um es noch einmal zu versuchen.',
};
